import * as Yup from "yup";



export const initialValues = {
    titleId: null,
    socialSecurityNo: null,
    registrationDocument: null,
    nationality: null,
    hospital: null,
    ssoReceivedDate: null,
    reasonForSsoResignation: null,
    remark: null,

};

const EmployeeSocialSecuritySchema = Yup.object().shape({
    // registrationDocument: Yup.string().required("Please select"),
    // nationality: Yup.string().required("Please select"),
    // hospital: Yup.string().required("Please select"),
    // ssoReceivedDate: Yup.string().required("Please choose"),
    socialSecurityNo: Yup.string().required(),
    employeeNationality: Yup.string(),
});

export default EmployeeSocialSecuritySchema;
